import React, { Suspense } from "react";
import "./App.css";
import axios from "axios";
import AttractScreen from "./components/screens/AttractScreen";
import AppState from "./util/AppState";
import WebsocketManager from "./util/WebsocketManager";
import SelectLanguageScreen from "./components/screens/SelectLanguageScreen";
import EnterLoyaltyCardScreen from "./components/screens/EnterLoyaltyCardScreen";
import AdminScreen from "./components/screens/AdminScreen";
import MessageScreen from "./components/screens/MessageScreen";
import StagingScreen from "./components/screens/StagingScreen";
import LoadingScreen from "./components/screens/LoadingScreen";
import FallbackLoadingScreen from "./components/screens/FallbackLoadingScreen";
import SelectSiteAndWallIDScreen from "./components/screens/SelectSiteAndWallIDScreen";
import ScannerDetailsScreen from "./components/screens/ScannerDetailsScreen";
import * as LDClient from "launchdarkly-js-client-sdk";
import calculateHMACToken from "./util/calculateHMACToken";
import { v4 as uuid_v4 } from "uuid";
import UnlockErrorMessage from "./util/UnlockErrorMessage";
import { logFunctions as log } from "./util/Logging";
import logger from "loglevel";
import { getI18n } from "react-i18next";
import { getDefaultLanguage } from "./util/GlobalFunctions";
import LoyaltyType from "./util/LoyaltyType";

class App extends React.Component {
  // enlint-disable-next-line
  constructor(props) {
    super(props);

    var org = localStorage.getItem("orgID");
    var stylesheetURL = localStorage.getItem("StyleSheetURL");
    var supportedLocales = localStorage.getItem("SupportedLocales");
    var sharedKey = localStorage.getItem("SharedKey");
    var secretKey = localStorage.getItem("SecretKey");
    var site = localStorage.getItem("siteID");
    var wall = localStorage.getItem("wallID");

    let initialState;

    if (
      org &&
      stylesheetURL &&
      supportedLocales &&
      sharedKey &&
      secretKey &&
      site &&
      wall
    ) {
      initialState = AppState.ATTRACT_SCREEN;
    } else {
      localStorage.clear();
      initialState = AppState.WELCOME_SCREEN;
    }

    this.state = {
      previousStateName: initialState,
      state: initialState,
      deviceStatusResponse: [],
      cardNumber: null,
      userType: null,
      initialAttract: false,
      scannerDetailsButtonEnabled: true,
      sitesList: [],
      searchText: null,
      devicesList: [],
    };
  }

  // constant values
  connectionTimeout = 15000;

  componentDidUpdate() {
    log.debug("+Appjs_componentDidUpdate(TRACE)");
    if (
      this.state.state === AppState.ATTRACT_SCREEN &&
      !this.state.initialAttract
    ) {
      this.setState({ initialAttract: true });
      log.info(
        "Appjs_componentDidUpdate() => Establishing websocket connection"
      );
      this.establishWebSocketConnectivity();
    }
    if (localStorage.getItem("SupportedLocales") !== null) {
      let kioskLanguage =
        localStorage.getItem("kioskLanguage") !== null
          ? localStorage.getItem("kioskLanguage")
          : JSON.parse(localStorage.getItem("SupportedLocales"))[0];
      if (getI18n().language !== kioskLanguage) {
        log.info(
          "Appjs_componentDidUpdate() => Current kiosk Language is: " +
            kioskLanguage
        );
        getI18n().changeLanguage(kioskLanguage);
        localStorage.setItem("kioskLanguage", kioskLanguage);
      }
    }
    log.debug("-Appjs_componentDidUpdate(TRACE)");
  }

  componentDidMount() {
    log.debug("+Appjs_componentDidMount(TRACE)");

    var org = localStorage.getItem("orgID");
    var site = localStorage.getItem("siteID");
    var wall = localStorage.getItem("wallID");

    var user = {
      key: org + site + wall || "newuser",
      custom: {
        host: window.location.host,
        org: org,
        site: site,
        wall: wall,
      },
    };
    var client = LDClient.initialize("61fd3736933c2616344d3970", user);
    client.on("ready", () => {
      logger.setDefaultLevel(client.variation("LOG_LEVEL", "info"));
      log.setLevel(client.variation("LOG_LEVEL", "info"));
      this.setState({
        scannerDetailsButtonEnabled: client.variation(
          "SCANNER_DETAILS",
          "false"
        ),
      });
    });

    client.on("change:LOG_LEVEL", function (value, previous) {
      logger.setDefaultLevel(client.variation("LOG_LEVEL", value));
      log.setLevel(client.variation("LOG_LEVEL", value));
    });

    client.on("change:SCANNER_DETAILS", function (value, previous) {
      this.setState({
        scannerDetailsButtonEnabled: client.variation("SCANNER_DETAILS", value),
      });
    });

    if (
      this.state.state === AppState.ATTRACT_SCREEN &&
      !this.state.initialAttract
    ) {
      this.setState({ initialAttract: true });
      log.info(
        "Appjs_componentDidMount() => Establishing websocket connection"
      );
      this.establishWebSocketConnectivity();
    }
    log.debug("-Appjs_componentDidMount(TRACE)");
  }

  establishWebSocketConnectivity() {
    log.debug("+Appjs_establishWebSocketConnectivity(TRACE)");
    let kioskUnlockEventHandlerMap = new Map();
    kioskUnlockEventHandlerMap.set("unlocked", (message) => {
      if (this.state.state === AppState.GETTING_READY_SCREEN) {
        this.setState({
          state: AppState.READY_SCREEN,
        });
      }
    });
    kioskUnlockEventHandlerMap.set("pickedUp", (message) => {
      let defaultLanguage = getDefaultLanguage();
      getI18n().changeLanguage(defaultLanguage);
      localStorage.setItem("kioskLanguage", defaultLanguage);
      if (this.state.state === AppState.READY_SCREEN) {
        this.setState({
          state: AppState.ATTRACT_SCREEN,
        });
      }
    });
    kioskUnlockEventHandlerMap.set("error", (message) => {
      if (
        this.state.state === AppState.GETTING_READY_SCREEN ||
        this.state.state === AppState.READY_SCREEN
      ) {
        switch (message) {
          case UnlockErrorMessage.NO_DEVICE_FOUND:
            this.setState({ state: AppState.NO_DEVICES_AVAILABLE_SCREEN });
            break;
          case UnlockErrorMessage.DEVICE_ALREADY_TAKEN:
            this.setState({ state: AppState.DEVICE_ALREADY_TAKEN_SCREEN });
            break;
          case UnlockErrorMessage.SCANNER_NOT_PICKED_UP:
            this.setState({ state: AppState.ATTRACT_SCREEN });
            break;
          case UnlockErrorMessage.UNLOCKING_TIMED_OUT:
            this.setState({ state: AppState.ERROR_SCREEN });
            break;
          default:
            this.setState({ state: AppState.ERROR_SCREEN });
            break;
        }
      }
    });
    kioskUnlockEventHandlerMap.set("open", () => {
      if (this.state.state === AppState.WEB_SOCKET_CONNECTION_ERROR_SCREEN) {
        this.setState({
          state: AppState.ATTRACT_SCREEN,
        });
      }
    });
    kioskUnlockEventHandlerMap.set("close", () => {
      if (this.state.state !== AppState.WEB_SOCKET_CONNECTION_ERROR_SCREEN) {
        this.setState({
          state: AppState.WEB_SOCKET_CONNECTION_ERROR_SCREEN,
        });
      }
      setTimeout(() => {
        this.establishWebSocketConnectivity();
      }, 3000);
    });
    this.wsm = new WebsocketManager(
      window.WEBSOCKETURL,
      kioskUnlockEventHandlerMap,
      localStorage.getItem("wallID")
    );
    log.setWebsocket(this.wsm);
    log.debug("-Appjs_establishWebSocketConnectivity(TRACE)");
  }

  transitionToAdminScreen(loyalty_id, userType) {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.ADMIN_SCREEN,
      cardNumber: loyalty_id,
      userType: userType,
    });
  }

  transitionToAttractScreen() {
    this.setState({
      state: AppState.ATTRACT_SCREEN,
    });
  }

  transitionToUnlockingScreen() {
    this.setState({
      state: AppState.GETTING_READY_SCREEN,
      previousStateName: this.state.state,
    });
  }

  transitionToSelectLanguageScreen() {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.SELECT_LANGUAGE_SCREEN,
    });
  }

  transitionToEnterLoyaltyCardScreen(searchText, devicesList) {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.ENTER_LOYALTY_CARD_SCREEN,
      searchText: searchText,
      devicesList: devicesList,
    });
  }

  transitionToProfileNotFoundScreen() {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.PROFILE_NOT_FOUND_SCREEN,
    });
  }

  transitionToStagingScreen() {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.STAGING_SCREEN,
    });
  }

  transitionToLoadingScreen() {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.LOADING_SCREEN,
    });
  }

  transitionToSelectIDScreen(sitesList) {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.SELECT_SITE_AND_WALL_ID_SCREEN,
      sitesList: sitesList,
    });
  }

  transitionToConfiguringScreen() {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.CONFIGURING_SCREEN,
    });
  }

  transitionToConfiguringSuccessScreen() {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.CONFIGURATION_SUCCESS,
    });
    setTimeout(() => {
      this.transitionToAttractScreen();
    }, 2000);
  }

  transitionToErrorStagingScreen() {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.ERROR_STAGING_SCREEN,
    });
  }

  transitionToNoDevicesAvailableScreen() {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.NO_DEVICES_AVAILABLE_SCREEN,
    });
  }

  transitionToDeviceAlreadyTakenScreen() {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.DEVICE_ALREADY_TAKEN_SCREEN,
    });
  }

  transitionToWelcomeScreen() {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.WELCOME_SCREEN,
    });
  }

  transitionToWebsocketConnectionErrorScreen() {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.WEB_SOCKET_CONNECTION_ERROR_SCREEN,
    });
  }

  transitionToScannerDetailsScreen(searchText, devicesList) {
    this.setState({
      previousStateName: this.state.state,
      state: AppState.SCANNER_DETAILS_SCREEN,
      searchText: searchText,
      devicesList: devicesList,
    });
  }

  updateDeviceStatusResponse(response) {
    this.setState({
      deviceStatusResponse: response,
    });
  }

  routeAsInvalidUser(response) {
    log.debug("+Appjs_routeAsInvalidUser(TRACE)");
    log.info(`Appjs_routeAsInvalidUser() => Response: ${response}`);
    this.transitionToProfileNotFoundScreen();
    setTimeout(() => {
      this.state.previousStateName === AppState.ENTER_LOYALTY_CARD_SCREEN
        ? this.transitionToEnterLoyaltyCardScreen()
        : this.transitionToAttractScreen();
    }, 3000);
    log.debug("-Appjs_routeAsInvalidUser(TRACE)");
  }

  checkUserType = (cardNumber, cardMask, cardMaskType) => {
    log.debug("+Appjs_checkUserType(TRACE)");
    let unmaskedText = cardMask.substr(0, cardMask.indexOf("*"));
    if (unmaskedText.length === 0) {
      unmaskedText = cardMask;
    }
    if (
      cardNumber.startsWith(unmaskedText) &&
      cardNumber.length === cardMask.length
    ) {
      log.info(
        "Appjs_checkUserType() => The card number is valid and is a " +
          cardMaskType
      );
      log.debug("-Appjs_checkUserType(TRACE)");
      return true;
    } else {
      log.info(
        "Appjs_checkUserType() => The card number is valid and is NOT " +
          cardMaskType
      );
      log.debug("-Appjs_checkUserType(TRACE)");
      return false;
    }
  };

  validateCustomer = (cardNumber) => {
    log.debug("+Appjs_validateCustomer(TRACE)");
    const date = new Date();
    const dateForAuth = date.toISOString().slice(0, 19) + ".000Z";
    const correlation_id = uuid_v4();
    const secretKey = window.atob(localStorage.getItem("SecretKey"));

    const hmacToken = calculateHMACToken(
      secretKey,
      localStorage.getItem("SharedKey"),
      localStorage.getItem("orgID"),
      dateForAuth,
      "GET",
      window.APIGEEPATH + `/profile/` + cardNumber,
      correlation_id
    );

    axios
      .get(window.SCANNERWALLPROXYURL + `/profile/` + cardNumber, {
        headers: {
          "nep-organization": localStorage.getItem("orgID"),
          "nep-correlation-id": correlation_id,
          Authorization: hmacToken,
          "Date-Header": date.toGMTString(),
        },
      })
      .then((response) => {
        log.info(
          "Appjs_validateCustomer() => Nep correlation Id: " +
            correlation_id +
            ". The response for get profile is: " +
            JSON.stringify(response.data)
        );
        if (response.status === 200) {
          if (!response.data.isBlocked && !response.data.Inactive) {
            log.info(
              "Appjs_validateCustomer() => Releasing the device in customer mode."
            );
            let payloadToServer = {
              cardNumber: cardNumber,
              userType: "customer",
              wallID: localStorage.getItem("wallID"),
            };
            this.transitionToUnlockingScreen();
            this.wsm.unlockWithCredentials(payloadToServer);
          } else {
            log.info(
              "Appjs_validateCustomer() => The customer card number is blocked or inactive"
            );
            this.routeAsInvalidUser(
              "The profile doesn't exist in the Customer Web Service"
            );
          }
        }
      })
      .catch((response) => {
        log.info(
          "Appjs_validateCustomer() => Transitioning to error screen with response - " +
            response
        );
        this.routeAsInvalidUser(response);
      });
    log.debug("-Appjs_validateCustomer(TRACE)");
  };

  processScan = (enteredText) => {
    log.debug("+Appjs_processScan(TRACE)");
    const text = enteredText;
    log.info("Appjs_processScan() => with entered text - " + text);
    if (this.state.previousStateName === AppState.SCANNER_DETAILS_SCREEN) {
      log.info(`Appjs_processScan() => The entered search text is: ${text}`);
      this.transitionToScannerDetailsScreen(
        text === "" ? undefined : text,
        this.state.devicesList
      );
    } else {
      if (text === null || text === "" || text.length <= 0) {
        log.info("Appjs_processScan() => cannot be empty!!");
        return;
      }
      log.info(`Appjs_processScan() => The entered text is: ${text}`);
      let userType = "";
      const customerCardMasks = JSON.parse(
        localStorage.getItem("customerCardMasks")
      );
      const attendantCardMasks = JSON.parse(
        localStorage.getItem("attendantCardMasks")
      );
      const managerCardMasks = JSON.parse(
        localStorage.getItem("managerCardMasks")
      );

      for (let i = 0; i < customerCardMasks.length; i++) {
        if (
          this.checkUserType(text, customerCardMasks[i], LoyaltyType.CUSTOMER)
        ) {
          this.validateCustomer(text);
          userType = LoyaltyType.CUSTOMER;
          break;
        }
      }

      if (userType !== LoyaltyType.CUSTOMER) {
        for (let i = 0; i < attendantCardMasks.length; i++) {
          if (
            this.checkUserType(
              text,
              attendantCardMasks[i],
              LoyaltyType.ATTENDANT
            )
          ) {
            userType = LoyaltyType.ATTENDANT;
            this.transitionToAdminScreen(text, userType);
            break;
          }
        }
      }

      if (
        userType !== LoyaltyType.CUSTOMER &&
        userType !== LoyaltyType.ATTENDANT
      ) {
        for (let i = 0; i < managerCardMasks.length; i++) {
          if (
            this.checkUserType(text, managerCardMasks[i], LoyaltyType.MANAGER)
          ) {
            userType = LoyaltyType.MANAGER;
            this.transitionToAdminScreen(text, userType);
            break;
          }
        }
      }

      if (userType === "") {
        log.info(
          "Appjs_processScan() => Invalid user - Transitioning to error screen"
        );
        this.routeAsInvalidUser(
          "The card number doesn't match with the patterns associated with this store."
        );
      }
    }
    log.debug("-Appjs_processScan(TRACE)");
  };

  renderState(state) {
    switch (state) {
      case AppState.ATTRACT_SCREEN:
        return (
          <AttractScreen
            transitionToUnlockingScreen={() =>
              this.transitionToUnlockingScreen()
            }
            unlockWithCredentials={(cardNumber) =>
              this.wsm.unlockWithCredentials(cardNumber)
            }
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
            transitionToEnterLoyaltyCardScreen={() =>
              this.transitionToEnterLoyaltyCardScreen()
            }
            processScan={(cardNumber) => this.processScan(cardNumber)}
          />
        );
      case AppState.GETTING_READY_SCREEN:
        setTimeout(() => {
          if (this.state.state === AppState.GETTING_READY_SCREEN) {
            this.setState({
              state: AppState.ERROR_SCREEN,
            });
          }
        }, this.connectionTimeout);
        return (
          <MessageScreen
            message={AppState.GETTING_READY_SCREEN}
            previousStateName={this.state.previousStateName}
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
          />
        );
      case AppState.READY_SCREEN:
        setTimeout(() => {
          if (this.state.state === AppState.READY_SCREEN) {
            this.setState({
              state: AppState.ATTRACT_SCREEN,
            });
          }
        }, this.connectionTimeout);
        return (
          <MessageScreen
            message={AppState.READY_SCREEN}
            previousStateName={this.state.previousStateName}
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
          />
        );
      case AppState.PROFILE_NOT_FOUND_SCREEN:
        return (
          <MessageScreen
            message={AppState.PROFILE_NOT_FOUND_SCREEN}
            previousStateName={this.state.previousStateName}
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
          />
        );
      case AppState.ADMIN_SCREEN:
        return (
          <AdminScreen
            cardNumber={this.state.cardNumber}
            userType={this.state.userType}
            scannerDetailsIsButtonEnabled={
              this.state.scannerDetailsButtonEnabled
            }
            transitionToScannerDetailsScreen={() =>
              this.transitionToScannerDetailsScreen()
            }
            transitionToAttractScreen={() => this.transitionToAttractScreen()}
            transitionToUnlockingScreen={() =>
              this.transitionToUnlockingScreen()
            }
            unlockWithCredentials={(cardNumber) =>
              this.wsm.unlockWithCredentials(cardNumber)
            }
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
          />
        );
      case AppState.SELECT_LANGUAGE_SCREEN:
        return (
          <SelectLanguageScreen
            transitionToAttractScreen={() => this.transitionToAttractScreen()}
            transitionToEnterLoyaltyCardScreen={() =>
              this.transitionToEnterLoyaltyCardScreen()
            }
            transitionToStagingScreen={() => this.transitionToStagingScreen()}
            transitionToWelcomeScreen={() => this.transitionToWelcomeScreen()}
            transitionToSelectIDScreen={(sitesList) =>
              this.transitionToSelectIDScreen(sitesList)
            }
            transitionToAdminScreen={() => this.transitionToAdminScreen()}
            transitionToNoDevicesAvailableScreen={() =>
              this.transitionToNoDevicesAvailableScreen()
            }
            transitionToDeviceAlreadyTakenScreen={() =>
              this.transitionToDeviceAlreadyTakenScreen()
            }
            transitionToWebsocketConnectionErrorScreen={() =>
              this.transitionToWebsocketConnectionErrorScreen()
            }
            previousStateName={this.state.previousStateName}
            sitesList={this.state.sitesList}
          />
        );
      case AppState.ENTER_LOYALTY_CARD_SCREEN:
        return (
          <EnterLoyaltyCardScreen
            transitionToAttractScreen={() => this.transitionToAttractScreen()}
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
            transitionToScannerDetailsScreen={(searchText, devicesList) =>
              this.transitionToScannerDetailsScreen(searchText, devicesList)
            }
            previousStateName={this.state.previousStateName}
            processScan={(cardNumber) => this.processScan(cardNumber)}
            devicesList={this.state.devicesList}
            searchText={this.state.searchText}
          />
        );

      case AppState.STAGING_SCREEN:
        return (
          <StagingScreen
            transitionToLoadingScreen={() => this.transitionToLoadingScreen()}
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
            transitionToErrorStagingScreen={() =>
              this.transitionToErrorStagingScreen()
            }
          />
        );
      case AppState.LOADING_SCREEN:
        return (
          <LoadingScreen
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
            transitionToSelectIDScreen={(sitesList) =>
              this.transitionToSelectIDScreen(sitesList)
            }
            transitionToErrorStagingScreen={() =>
              this.transitionToErrorStagingScreen()
            }
            state={AppState.LOADING_SCREEN}
          />
        );
      case AppState.SELECT_SITE_AND_WALL_ID_SCREEN:
        return (
          <SelectSiteAndWallIDScreen
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
            transitionToConfiguringScreen={() =>
              this.transitionToConfiguringScreen()
            }
            transitionToStagingScreen={() => this.transitionToStagingScreen()}
            sitesList={this.state.sitesList}
          />
        );
      case AppState.CONFIGURING_SCREEN:
        return (
          <LoadingScreen
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
            transitionToConfiguringSuccessScreen={() =>
              this.transitionToConfiguringSuccessScreen()
            }
            transitionToErrorStagingScreen={() =>
              this.transitionToErrorStagingScreen()
            }
            state={AppState.CONFIGURING_SCREEN}
          />
        );
      case AppState.CONFIGURATION_SUCCESS:
        return (
          <MessageScreen
            message={AppState.CONFIGURATION_SUCCESS}
            previousStateName={this.state.previousStateName}
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
          />
        );
      case AppState.ERROR_STAGING_SCREEN:
        return (
          <MessageScreen
            message={AppState.ERROR_STAGING_SCREEN}
            previousStateName={this.state.previousStateName}
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
            transitionToStagingScreen={() => this.transitionToStagingScreen()}
          />
        );
      case AppState.NO_DEVICES_AVAILABLE_SCREEN:
        setTimeout(() => {
          this.setState({
            state: AppState.ATTRACT_SCREEN,
          });
        }, 3000);
        return (
          <MessageScreen
            message={AppState.NO_DEVICES_AVAILABLE_SCREEN}
            previousStateName={this.state.previousStateName}
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
          />
        );
      case AppState.DEVICE_ALREADY_TAKEN_SCREEN:
        setTimeout(() => {
          this.setState({
            state: AppState.ATTRACT_SCREEN,
          });
        }, 3000);
        return (
          <MessageScreen
            message={AppState.DEVICE_ALREADY_TAKEN_SCREEN}
            previousStateName={this.state.previousStateName}
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
          />
        );
      case AppState.WELCOME_SCREEN:
        return (
          <MessageScreen
            message={AppState.WELCOME_SCREEN}
            previousStateName={this.state.previousStateName}
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
            transitionToStagingScreen={() => this.transitionToStagingScreen()}
          />
        );
      case AppState.WEB_SOCKET_CONNECTION_ERROR_SCREEN:
        return (
          <MessageScreen
            message={AppState.WEB_SOCKET_CONNECTION_ERROR_SCREEN}
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
          />
        );
      case AppState.SCANNER_DETAILS_SCREEN:
        return (
          <ScannerDetailsScreen
            searchText={this.state.searchText}
            devicesList={this.state.devicesList}
            transitionToAdminScreen={() =>
              this.transitionToAdminScreen(
                this.state.cardNumber,
                this.state.userType
              )
            }
            transitionToEnterLoyaltyCardScreen={(searchText, devicesList) =>
              this.transitionToEnterLoyaltyCardScreen(searchText, devicesList)
            }
          />
        );
      default:
        setTimeout(() => {
          this.setState({
            state: AppState.ATTRACT_SCREEN,
          });
        }, 3000);
        return (
          <MessageScreen
            message={AppState.ERROR_SCREEN}
            previousStateName={this.state.previousStateName}
            transitionToSelectLanguageScreen={() =>
              this.transitionToSelectLanguageScreen()
            }
          />
        );
    }
  }

  render() {
    return (
      <Suspense fallback={<FallbackLoadingScreen />}>
        <link
          rel="stylesheet"
          type="text/css"
          href={localStorage.getItem("StyleSheetURL")}
        />
        <div className="App">{this.renderState(this.state.state)}</div>
      </Suspense>
    );
  }
}

export default App;
